import axios from "axios";


const RESTAURANT_API_HOST = process.env.REACT_APP_API_RESTAURANT_URL

const axiosRestaurantInstance = axios.create({
  baseURL: RESTAURANT_API_HOST, //"http://127.0.0.1:5001",
  headers:{
    'Content-Type':'application/json'
  }
});

export default axiosRestaurantInstance;
